import { z } from "zod";

import { Media } from "@/components/forms/schemas/media";

export const venueNestedSchema = z.object({
  id: z.string(),
  // `.default("")`, not a bare `z.string()`: 61 prod venues predate the
  // 2026-06-19 venue slug generation and still carry `slug: ""`. AutoForm's
  // `removeEmptyValues` deletes every `""` before it validates, so a bare
  // required string turned one of those into `venue.slug -> "Required"` —
  // and AutoForm copies a nested error onto its parent path, so the message
  // landed on the Venue picker itself with no way to clear it. Swapping an
  // event onto such a venue was unsubmittable.
  slug: z.string().default(""),
  name: z.string(),
  media: Media,
  followers: z.number().default(0),
  geolocation: z.object({
    latitude: z.coerce.number(),
    longitude: z.coerce.number(),
  }),
  address: z.string(),
  mapsUrl: z.string().url().nullish(),
  status: z.string(),
  // only for managing other fields, not editable
  timezone: z.string().readonly().nullish(),
  geodata: z
    .object({
      name: z.string(),
      country: z.string(),
    })
    .readonly()
    .nullish(),
  embedding: z.array(z.number()).optional(),
});

export type VenueNestedType = z.infer<typeof venueNestedSchema>;
